import {
  GetCaseOverviewDetailsQuery,
  GetCaseVerificationsQuery,
  Verification,
  VerificationCollection,
  VerificationFlagStatus,
} from '@acre/graphql'

export const hasCaseVerificationCollections = (data: GetCaseVerificationsQuery['case']) =>
  data &&
  data.details &&
  data.details.verifications &&
  data.details.verifications.verification_collections &&
  data.details.verifications.verification_collections.length > 0

export const groupCaseVerfications = (data: GetCaseVerificationsQuery['case']) =>
  data.details.verifications!.verification_collections.reduce(
    (acc: Verification[], verificationCollection: VerificationCollection) => {
      if (
        verificationCollection &&
        verificationCollection.verifications &&
        verificationCollection.verifications.length > 0
      ) {
        return [...acc, ...verificationCollection.verifications]
      }
      return acc
    },
    [],
  )

export const hasVerificationFlags = (verifications: Verification[]) =>
  verifications.findIndex(
    (verification) =>
      verification.flag &&
      Object.values(VerificationFlagStatus).includes(verification.flag) &&
      // TODO: FRON-1150 currently flags are not editable, this condition is temporary
      VerificationFlagStatus.FlagNone !== verification.flag &&
      VerificationFlagStatus.FlagCleared !== verification.flag,
  ) > -1

export const findDocument = (data: GetCaseOverviewDetailsQuery['case'], documentId: string) =>
  data && data.details.documents && data.details.documents.find((document) => document.document_id === documentId)

export const hasPassedVerifications = (verificationIds: string[], passedVerificationIds?: string[]) => {
  if (!verificationIds.length) {
    return true
  } else {
    if (!passedVerificationIds) return false
  }

  //go through each ids and check if their status is passed if not return false
  return verificationIds.every((id) => passedVerificationIds.includes(id))
}
